import { InsType } from 'constants/enums/insType.enum';
import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootReducersState } from 'redux/reducers';
import commonService from 'utils/commonService';
import { ChildDataContent, DataContent, IProps } from './types';

const Table: React.FC<IProps> = (props) => {
  const tableRef = useRef<HTMLDivElement>(null);
  const [tableElemHeight, setTableElemHeight] = useState(0);
  const resources = useSelector((state: RootReducersState) => state.resources);

  useEffect(() => {
    const tableElemHeight = (props.detailOpen && tableRef && tableRef.current) ? tableRef.current.clientHeight : 0;
    setTableElemHeight(tableElemHeight);
  }, [props.detailOpen, props.DATA]);

  /**
   * @description 建立表單資料
   */
  const handleCreateCotnet = (datas: DataContent[]) => {
    switch (props.INS_TYPE_ID) {
      case InsType.MobileDevice: {
        return _.map(datas, (data: DataContent, dataIndex: number) => {
          return React.cloneElement(
            <>
              {
                data.ITEM_TITLE && (
                  <tr className="insured-content__table-ins-title">
                    <th>{data.ITEM_TITLE}</th>
                  </tr>
                )
              }
              {
                data.CHILD_DATA && data.CHILD_DATA.length > 0 && _.map(data.CHILD_DATA, (childData: ChildDataContent, childIndex: number) => {
                  return (
                    <tr key={childIndex}>
                      <td>{childData.ITEM_NAME}</td>
                      <td>{childData.DISCOUNT_AMT}</td>
                    </tr>
                  );
                })
              }
            </>
            , { key: dataIndex }
          );
        });
      }
      case InsType.Car:
      case InsType.Moto: {
        return _.map(datas, (data: DataContent, dataIndex: number) => {
          return React.cloneElement(
            <>
              {
                data.ITEM_TITLE && (
                  <tr className="insured-content__table-ins-title">
                    <th colSpan={3}>{data.ITEM_TITLE}</th>
                  </tr>
                )
              }
              {
                data.CHILD_DATA && data.CHILD_DATA.length > 0 && _.map(data.CHILD_DATA, (childData: ChildDataContent, childIndex: number) => {
                  return (
                    <tr key={childIndex}>
                      <td>{childData.ITEM_NAME}</td>
                      <td>{childData.DISCOUNT_AMT}</td>
                    </tr>
                  );
                })
              }
            </>
            , { key: dataIndex }
          );
        });
      }
      default: {
        return _.map(datas, (data: DataContent, dataIndex: number) => {
          return React.cloneElement(
            <>
              {
                data.ITEM_TITLE && (
                  <tr className="insured-content__table-ins-title">
                    <th colSpan={3}>{data.ITEM_TITLE}</th>
                  </tr>
                )
              }
              {
                data.CHILD_DATA && data.CHILD_DATA.length > 0 && _.map(data.CHILD_DATA, (childData: ChildDataContent, childIndex: number) => {
                  return (
                    <tr key={childIndex}>
                      <td>{childData.ITEM_NAME}</td>
                      <td>{childData.ITEM_AMT}</td>
                      <td>{childData.DISCOUNT_AMT}</td>
                    </tr>
                  );
                })
              }
            </>
            , { key: dataIndex }
          );
        });
      }
    }
  };

  return (
    <div className="insured-content__table" style={{ height: tableElemHeight }}>
      <div ref={tableRef}>
        <table>
          <tbody>
            <tr className="insured-content__table-title">
              <th>{commonService.getNameByLng(resources, 'TID_Insurance_content_th')}</th>
              {!props.INS_TYPE_ID || (props.INS_TYPE_ID !== InsType.MobileDevice && props.INS_TYPE_ID !== InsType.Car && props.INS_TYPE_ID !== InsType.Moto) ? (
                <th>{commonService.getNameByLng(resources, 'TID_Insurance_Amount')}</th>
              ) : null}
              {props.INS_TYPE_ID !== InsType.MobileDevice ? (<th>{commonService.getNameByLng(resources, 'TID_Premium')}</th>) : null}
            </tr>
            {
              props.DATA && props.DATA.length > 0 && handleCreateCotnet(props.DATA)
            }
            <tr>
              {props.INS_TYPE_ID !== InsType.MobileDevice ? (
                <td colSpan={3}>{`${commonService.getNameByLng(resources, 'TID_Premium_Total')}：NT$ ${props.TOTAL_FEE} ${commonService.getPriceUnitByLng(resources)}`}</td>) : null}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
